import { Page } from 'src/Models';
import { API_BASE_URL } from 'src/modules/api/endpoints';
import fetch from 'fetch-retry';

interface ITasksQueueOptions {
  tasksList: ITaskData[];
  storageName: string;
}

interface ITaskData {
  type: string;
  retriesCount: number;
  retryDelay: number;
  requestOptions: any;
}

export default class TasksQueue {
  public tasksList: ITaskData[] = [];
  private storageName: string;

  constructor(options: ITasksQueueOptions) {
    this.tasksList = options.tasksList;
    this.storageName = options.storageName;
  }

  public async start(token: string): Promise<Page[]> {
    const completedTasks: Page[] = [];

    for (const task of this.tasksList) {
      try {
        const page = await this.run(task, token);
        completedTasks.push(page);
      } catch (e) {
        const taskIndex = this.tasksList.indexOf(task);

        this.tasksList.splice(0, taskIndex);
        this.save();

        return Promise.reject(e);
      }
    }

    this.clearQueue();

    return Promise.resolve(completedTasks);
  }

  public clearQueue = () => {
    this.tasksList = [];
    this.save();
  };

  public load(): TasksQueue {
    const rawTasksData: string = localStorage.getItem(this.storageName) || '';
    try {
      this.tasksList = JSON.parse(rawTasksData) as ITaskData[];
    } catch (e) {
      this.tasksList = [];
    }
    return this;
  }

  private async run(taskData: ITaskData, token: string): Promise<any> {
    const endpoint = taskData.requestOptions.url!;
    const pagePayload = taskData.requestOptions.data;
    const method = 'POST';

    const jsonResponse = this.executePageRequest(endpoint, token, method, pagePayload);

    return jsonResponse;
  }

  private save(): TasksQueue {
    localStorage.setItem(this.storageName, JSON.stringify(this.tasksList));
    return this;
  }

  private async executePageRequest(endpoint: string, token: string, method: string, pagePayload: any): Promise<Page> {
    const url = `${API_BASE_URL}${endpoint}`;
    const response = await fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(pagePayload),
      retries: 3,
      retryDelay: 1000,
      retryOn(attempt: number, error: Error, resp: any) {
        // retry on any network error, or 4xx or 5xx status codes
        if (error !== null || resp.status >= 400) {
          return true;
        } else {
          return false;
        }
      },
    });

    const jsonResponse = await response.json();

    return jsonResponse;
  }
}



// WEBPACK FOOTER //
// ./src/modules/appSync/core/TasksQueue.ts